import React, { useState } from 'react';
import MUIDataTable from "mui-datatables";
import { useEffect } from 'react';
import { format } from 'date-fns';
import { Row, Card, Col, Dropdown, Button, Modal, Container } from "react-bootstrap";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { accountApi, addUser, deleteUser, listRole_twoApi, getMarket, crewCompanyApi, mpimtracker, listUserApi_two, vendorApi, viewmpimtracker, addAcccount, listOneUser, updateUser, CsvUpload, tierapi, viewmpimpo, mpimpo, managEngineer, OneSiteDatabaseProjectCode } from '../../../common/config';
import { AccountReducerAction, OneUserReducerAction, addUserAction, deleteAcccountReducerAction, TierListReducerActionviewtracker, GetMarketReducerAction, getCrewCompanyAction, updateAcccountReducerAction, RoleReducerAction, UserListReducerAction, TierListReducerAction, OneTierReducerAction, FetchSingleRecordAction, popUpUpdate, GetOneUserAction } from '../../../store/actions/createTicketManageFields';
import { useDispatch, useSelector } from 'react-redux';
import { MultiSelect } from "react-multi-select-component";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { black } from 'material-ui/styles/colors';
import { google_map_api, center, dbdatetodate, customDataTableOptionObject, advancdExportOnecustomDataTableOptionObject, getMuiThemeCommon } from "../../../common/variables";
import DatePicker from "react-datepicker";
import CommonModal from "../Custom/CommonModal";

import {
  // google_map_api,
  // center,
  // dbdatetodate,
  // customDataTableOptionObject,
  // advancdExportOnecustomDataTableOptionObject,
  // getMuiThemeCommon,
  wrapText,
} from "../../../common/variables";


import { PDFUploadActionreturn } from '../../../store/actions/dashboardActions';
import CommonBulkUploader from '../Custom/CommonBulkUploader';
import moment from 'moment';


const ViewSchedulerTracker = () => {
  let user = useSelector((state) => {
    let onelistuser = state.OneCommonResponse.listuser
    if (onelistuser.length > 0) {
      // oneaccount = onelistuser[0]
      return onelistuser[0]
      // console.log(oneaccount, "oneaccount")
      // seteditTrue(0)
      // seteditdataHandler(oneaccount)
    }

  })
  let pStatusArry = []
  let vStatusArry = []
  let mStatusArry = []
  let cStatusArry = []
  let allProjects = []




  // let editTrue=0
  const options = {
    download: "false",
    filterType: 'none',
    selectableRows: false,
    responsive: true
  };

  let accountArry = []
  let tierArry = []


  const { register, setValue, handleSubmit, reset, formState: { errors } } = useForm({});
  const [show, setShow] = useState(false);
  const [closer, setCloser] = useState(false);
  const [siteFile, uploadedFile] = useState([]);
  const [fileshow, setfileShow] = useState(false);
  let [sImpact, setSectorImpact] = useState([])
  let [marketts, setMarkets] = useState([])
  const [date, setdssate] = useState();
  const [dateassigned, setdsate] = useState();
  const [dateCompleted, setDateCompleted] = useState('');




  const submitHandler = async (e) => {
    e.preventDefault();
    console.log("form==", "form")
    let newform = new FormData();
    newform.append("uploadFile", siteFile);
    newform.append("uploadfor", "Crew")
    console.log("form==", newform)
    console.log("resp", dispatch(PDFUploadActionreturn(CsvUpload, newform, "usercrew")))
    setShow(false);
  };


  const uploadCsvFile = (e) => {
    // let files=[]
    console.log(e.target.files, "files")
    uploadedFile(e.target.files[0])

  };

  const handleClose = () => {
    reset({})
    setShow(false);
  }
  const handleShow = () => {
    reset({})
    setShow(true)
  }

  const filehandleClose = () => {
    reset({})
    setfileShow(false);
  }
  const filehandleShow = () => {
    reset({})
    setfileShow(true)
  }

  const handleSectorImpect = (e) => {
    setSectorImpact(e)
    setDepartmentError(false)
    console.log(sImpact, "sImpact")
  }

  const handleMarket = (e) => {
    setMarkets(e)
    setMarketError(false)
    console.log(marketts, "marketts")
  }

  let sectorsImpacted = [
    // {
    //   value: "MPAG",
    //   label: "MPAG"
    // },
    // {
    //   value: "MOP",
    //   label: "MOP"
    // },
    {
      value: "RAN SUPPORT",
      label: "RAN SUPPORT"
    },
    // {
    //   value: "IX SUPPORT",
    //   label: "IX SUPPORT"
    // },
    {
      value: "TROUBLE TICKET",
      label: "TROUBLE TICKET"
    },
    {
      value: "E911 CALL TEST",
      label: "E911 CALL TEST"
    },
    {
      value: "FOURTY EIGHT",
      label: "FOURTY EIGHT"
    },
    {
      value: "POST IX RF SUPPORT",
      label: "POST IX RF SUPPORT"
    },
    {
      value: "CIQ SCRIPTING",
      label: "CIQ SCRIPTING"
    },
    {
      value: "NETWORK DATABASE",
      label: "NETWORK DATABASE"
    },
    {
      value: "T MOBILE DASHBOARD",
      label: "T MOBILE DASHBOARD"
    },
    {
      value: "MPAG",
      label: "MPAG"
    },
    {
      value: "TRAINING",
      label: "TRAINING"
    },
    {
      value: "ADMIN",
      label: "ADMIN"
    },
  ]
  // const uploadCsvFile = (e) => {
  //   let files=[]

  //   console.log(e.target.files[0],"ON_CHANGE_FILES:", e.target.files.length);

  //   for(let i=0;i<e.target.files.length;i++){
  //     files.push(e.target.files[i])
  //   }
  //   console.log(...files)
  //   uploadedFile(files)

  // };

  let optionss = useSelector((state) => {
    let technology = state.CommonResponse.technology;
    let sites_Id = state?.OneCommonResponse?.site_id;
    let site_idss = sites_Id?.map((p) => {
      console.log(p.site_id, "hushuhushus");
      return <option>{p?.site_id}</option>;
    });



    return { site_idss };
  });



  const engineers = useSelector(state => state.OneCommonResponse.engineers)

  const accountss = useSelector(state => state.OneCommonResponse.accounts)

  const marketnames = useSelector(state => state.OneCommonResponse.marketName)

  const incTicket = useSelector(state => state.OneCommonResponse.inc_ticket)

  const siteid = useSelector(state => state.OneCommonResponse.site_id)

  const findDSiteId = (id) => {
    console.log(id, "findDSiteId", allProjects);




    // if (id != undefined && customesite != id) {
    //     setcustomesite(id);
    //     setoneprid("");
    //     setppProjctId("");
    //     setTech([]);
    //     setProjectId([]);
    //     setProjectCode([]);
    //     dispatch(clearGetSingleProjectDatabase());
    //     dispatch(clearProjectId());
    //     dispatch(ClearProductCode());
    //     // projectData.singleSite = []
    //     if (allProjects.length > 0)
    //         console.log(
    //             "the respasfsdvgfdsbdtrh =",
    //             ...allProjects.filter((item) => item.siteId == id)
    //         );
    //     let idObject = allProjects.filter((item) => item.siteId == id);
    //     if (idObject.length > 0) {
    // setond(true)

    // dispatch(FetchSingleRecordAction(projectCode, allProjects.filter((item) => item.siteId == id)[0].uniqueSiteId))   //from project Databasee
    dispatch(FetchSingleRecordAction(OneSiteDatabaseProjectCode, id)); //from network Databasee
    //     }
    // } else {
    // setSiteError(true)
    // }
  };

  const [commonModalState, setcommonModalState] = useState(false);
  const [commonModalSize, setcommonModalSize] = useState(false);
  const [commonModalBody, setcommonModalBody] = useState("");
  const [commonModalTitle, setcommonModalTitle] = useState("");
  const [commonModalHeader, setcommonModalHeader] = useState("");

  const [modalCentered, setModalCentered] = useState(false);
  const [newAccount, setAccount] = useState({})
  const [editTrue, seteditTrue] = useState(0)
  const [ven, setVen] = useState('')
  const [departmentError, setDepartmentError] = useState(false)
  const [marketError, setMarketError] = useState(false)
  const [updateTrue, setupdateTrue] = useState(0)
  const [formtype, addformtype] = useState('')

  // const [dateCompleted, setDateCompleted] = useState("");
  const [analysisStatus, setAnalysisStatus] = useState("");


  const handleStatusChange = (event) => {
    const selectedStatus = event.target.value;
    setAnalysisStatus(selectedStatus);

    const selectElement = document.getElementById("Analysis_Status");
    console.log("djaldja", selectElement)
    const options = Array.from(selectElement.options);
    options.sort((a, b) => {
      if (a.value === "Pending") return -1;
      if (b.value === "Complete") return 1;
      return 0;
    });

    selectElement.innerHTML = "";
    options.forEach((option) => selectElement.appendChild(option));
  };







  let oneaccount = {}


  // setAccount(oneaccount)
  //  console.log(oneaccount,"oneaccount")
  const getMuiTheme = () => createTheme({
    components: {
      MUIDataTableBodyCell: {
        styleOverrides: {
          root: {
            backgroundColor: "transparent",
            color: black
          }
        }
      }
    }
  })



  console.log()
  const updateHandler = (e) => {
    console.log("button update clicked", e)

    dispatch(addUserAction(mpimtracker, e))

  }
  const deleteHandler = (e) => {
    console.log("button delete clicked", e)

    dispatch(deleteAcccountReducerAction(mpimtracker, e, "tier"))
    setCloser(true)
  }

  const CommonModalFun = (body, title, header, type = "md") => {
    setcommonModalState(true);
    setcommonModalSize(type);
    setcommonModalTitle(title);
    setcommonModalBody(body);
    setcommonModalHeader(header);
  };

  const editpopupHandler = (e) => {

    dispatch(GetOneUserAction([]))
    seteditTrue(1)
    reset({})
    console.log("button editpopupHandler clicked", e)
    dispatch(OneTierReducerAction(viewmpimtracker + "/" + e.uniqueid))
  }

  const seteditdataHandler = (e) => {

    console.log(e,"jdhakjhadjkhdj")
    reset({})
    setupdateTrue(1)
    setDateCompleted('');


    // let date = e.date?.split("/").reverse().join("/");
    // console.log("hjgsadadda", date);

    // const parsedDate = moment(date, 'MM/DD/YYYY', true);
    // console.log("ssssssadadda", parsedDate);

    // if (!isNaN(parsedDate)) {
    //   setDateCompleted(parsedDate.toDate());
    // } else {
    //   console.log("Invalid Date");
    //   clearDateState();
    // }


    // let date = e.date?.split("/").reverse().join("/");
    // const parsedDate = new Date(date);
    // console.log("hjgsadaddaasddssd", parsedDate);
    // if (!isNaN(parsedDate)) {
    //   setDateCompleted(parsedDate);
    // } else {
    //   console.log("Invalid Date");
    //   clearDateState();
    // }

    let date = e.date?.split("/");
    if (date && date.length === 3) {
      // Reformat the date string to "yyyy/mm/dd"
      const formattedDate = `${date[2]}/${date[0]}/${date[1]}`;
      console.log("Original Date:", e.date);
      console.log("Formatted Date:", formattedDate);
    
      const parsedDate = new Date(formattedDate);
      if (!isNaN(parsedDate)) {
        console.log("Parsed Date:", parsedDate);
        setDateCompleted(parsedDate);
      } else {
        console.log("Invalid Date");
        clearDateState();
      }
    } else {
      console.log("Invalid Date Format");
      clearDateState();
    }
    


    let dateassigned = e.dateassigned?.split("/");
    if (dateassigned && dateassigned.length === 3) {
      // Reformat the date string to "yyyy/mm/dd"
      const formattedDate = `${dateassigned[2]}/${dateassigned[0]}/${dateassigned[1]}`;
      console.log("Original Date:", e.dateassigned);
      console.log("Formatted Date:", formattedDate);
    
      const parsedDate1 = new Date(formattedDate);
      if (!isNaN(parsedDate1)) {
        console.log("Parsed Date:", parsedDate1);
        setdsate(parsedDate1);
      } else {
        console.log("Invalid Date");
        clearDateState();
      }
    } else {
      console.log("Invalid Date Format");
      clearDateState();
    }



    // let dateassigned = e.dateassigned?.split("/").reverse().join("/");
    // console.log("hjgsadadda", dateassigned);
    // const parsedDate1 = new Date(dateassigned);
    // if (!isNaN(parsedDate1)) {
    //   setdsate(parsedDate1);
    // } else {
    //   console.log("Invalid Date");
    // }

    // const [incticket, setincticket] = useState(true)

    // dispatch(AccountReducerAction('/manage_inc_ticket/' + e.site_id));

    dispatch(FetchSingleRecordAction(OneSiteDatabaseProjectCode, e.site_id));

    setValue("account_name", e.account_name, { shouldTouch: true });
    setValue("market_name", e.market_name, { shouldTouch: true });
    setValue("datetimed", e.datetimed, { shouldTouch: true });
    setValue("site_id", e.site_id, { shouldTouch: true });
    setValue("Analysis_Status", e.Analysis_Status, { shouldTouch: true });
    setValue("inc_ticket", e.inc_ticket, { shouldTouch: true });
    setValue("xPEX", e.xPEX, { shouldTouch: true });
    setValue("bridge_support", e.bridge_support, { shouldTouch: true });
    setValue("assigned_to", e.assigned_to, { shouldTouch: true });
    setValue("shift", e.shift, { shouldTouch: true });
    setValue("hoReqired_to", e.hoReqired_to, { shouldTouch: true });
    setValue("notes", e.notes, { shouldTouch: true });
    setValue("ho_engineer", e.ho_engineer, { shouldTouch: true });
    setValue("dateassigned", e.dateassigned, { shouldTouch: true });
    setValue("date", e.date, { shouldTouch: true });

    // setValue('date', e.newDateCompleted, { shouldTouch: true });

    console.log('ggyyggg', e.date)

    // console.log(e.$oid,"e.$oid")
    // setValue("userrole", e.userroleuniqueid, { shouldTouch: true });
    // setValue("accountId", e.accountuniqueid, { shouldTouch: true });
    // setValue("vendor", e.vendorId, { shouldTouch: true });
    // setVen(e.vendorId);
    // console.log("vener", e.vendorId, "vener")
    // setValue("name", e.name, { shouldTouch: true });
    setValue("uniqueid", e.uniqueid, { shouldTouch: true });
    let arr = []
    arr = e?.department?.values?.map((item) => {
      return {
        value: item,
        label: item,
      };
    })

    setSectorImpact(arr)

    let arrm = []
    arrm = e?.markets?.values?.map((item) => {
      return {
        value: item,
        label: item,
      };
    })

    setMarkets(arrm)
  }

  const clearDateState = () => {

    setdssate("");
  };



  const onSubmit = async (data) => {

    let arrmarketts = { values: [] }
    if (sImpact?.length == 0) {

      setDepartmentError(true)
      return (null)
    }
    if (marketts?.length == 0) {
      setMarketError(true)
      return (null)
    }
    let tiier = { values: [] }
    tiier.values = sImpact?.map((item) => {
      return item.value
    })
    data['department'] = tiier
    arrmarketts.values = marketts?.map((item) => {
      return item.value
    })
    data['markets'] = arrmarketts
    console.log(data, "dassdaas")

    // if (date != null) {
    //   data["date"] = moment(date).format("DD/MM/YYYY")
    // }


    if (data.uniqueid != undefined) {
      const isDateEdited = typeof (date) != typeof (new Date());
      const isDateAssignedEdited = typeof (dateassigned) != typeof (new Date());
      console.log(date, new Date(), typeof (date), typeof (new Date()), "updateAcccountReducerAction")
      // data["date"] = isDateEdited ? '' : date == null ? "" : moment(date).format("MM/DD/YYYY");
      data["date"] = dateCompleted ? moment(dateCompleted).format("MM/DD/YYYY") : moment(date).format("MM/DD/YYYY")
      data["dateassigned"] = isDateAssignedEdited ? '' : dateassigned == null ? "" : moment(dateassigned).format("MM/DD/YYYY");
      console.log(isDateEdited, isDateAssignedEdited, "updateAcccountReducerAction")

      dispatch(updateAcccountReducerAction(mpimtracker, data.uniqueid, data, "department"));
      console.log("updateAcccountReducerAction", data)
      setCloser(true)
    }
    else {
      dispatch(addUserAction(mpimtracker, data, "department"))
      setCloser(true)
    }

  }

  const dispatch = useDispatch();


  // let datava =useSelector((state)=>{

  // });

  let data = useSelector((state) => {
    console.log("dfwef=", state)
    let onelistuser = state.OneCommonResponse.listuser

    // console.log(onelistuser.length, editTrue, "onelistuser")
    if (onelistuser.length > 0 && editTrue == 1) {
      oneaccount = onelistuser[0]
      console.log(oneaccount, "oneaccount")
      seteditTrue(0)
      seteditdataHandler(oneaccount)
    }

    // console.log(state.popUpState,"popUpState")

    if (state.popUpState) {
      // console.log(state.popUpState.popstatus.status==201,"popUpStatestatus")
      if (state.popUpState.popstatus.status == 201 && closer) {
        setCloser(false)
        handleClose()
        dispatch(TierListReducerActionviewtracker(viewmpimtracker))
        popUpUpdate({})
      }
    }


    let tier = state.CommonResponse.listtierviewtracker

    let account = state.CommonResponse.accounts
    let index = 0
    if (tier && tier.length != 0) {
      tierArry = tier.map((item) => {

        console.log(item, "itemitemitemitemitemitem")
        index = index + 1
        return {


          account_name: item.account_name,
          market_name: item.market_name,
          datetimed: item.datetimed,
          site_id: item.site_id,
          // Analysis_Status: item.Analysis_Status,
          Analysis_Status_view: <><p className={item.Analysis_Status === 'Pending' ? "badge badge-warning" : 'badge badge-primary'}>{item.Analysis_Status}</p></>,
          Analysis_Status_print: item.Analysis_Status,
          inc_ticket: item.inc_ticket,
          xPEX: item.xPEX,
          bridge_support: item.bridge_support,
          assigned_to: item.assigned_to,
          shift: item.shift,
          hoReqired_to: item.hoReqired_to,
          // notes: item.notes,
          notes_display: (
            <p
              className={"text-black my-0 modalHoverClass"}
              onClick={() =>
                CommonModalFun(
                  <p
                    style={{
                      border: "2px solid black",
                      color: "black",
                      padding: 2,
                    }}
                    className="CommonModal"
                  >
                    {item.notes}
                  </p>,
                  "Comment",
                  "Notes"
                )
              }
            >
              {wrapText(item.notes)}
            </p>
          ),

          notes_print:item.notes,
          ho_engineer: item.ho_engineer,
          date: item.date,
          dateassigned: item.dateassigned,
          action: <div className="d-flex">
            <Link
              href="#"
              onClick={() => { editpopupHandler(item); reset({}); addformtype("Edit"); handleShow(); }}
              className="btn btn-primary shadow btn-xs sharp mr-1"
            >
              <i className="fa fa-pencil"></i>
            </Link>
            <Link
              href="#"
              onClick={(e) => deleteHandler(item.uniqueid)}
              className="btn btn-danger shadow btn-xs sharp"
            >
              <i className="fa fa-trash"></i>
            </Link>
          </div>
          // <button value={item.uniqueid} onClick={(e)=>updateHandler(e)}>Click me</button>

        }
      })
    }


    if (account != 0) {
      accountArry = account.map((item) => {
        return <option value={item.uniqueid}>{item.accountName}</option>
      })
    }


    let userroledata = state.CommonResponse.userrole
    console.log(state, "state.CommonResponse")
    console.log(userroledata, "projectStatus")
    if (userroledata != 0) {
      pStatusArry = userroledata.map((item) => {
        return <option value={item.uniqueid}>{item.rolename}</option>
      })

    }


    let markarr = []
    let marketroledata = state.CommonResponse.markets
    if (marketroledata != 0) {

      mStatusArry = marketroledata.map((item) => {
        return {
          value: item.marketName,
          label: item.marketName,
        };
      })

    }
    let crewroledata = state.CommonResponse.crewCompany
    if (crewroledata != 0) {
      cStatusArry = crewroledata.map((item) => {
        return <option value={item.uniqueid}>{item.crewCompanyName}</option>
      })

    }

    let vendorroledata = state.CommonResponse.vendor
    if (vendorroledata != 0) {
      vStatusArry = vendorroledata.map((item) => {
        console.log(ven, item.uniqueid, "ven==item.uniqueid")
        return <option value={item.uniqueid}>{item.vendorName}</option>
        // if(ven==item.uniqueid){
        //   return <option selected value={item.uniqueid}>{item.vendorName}</option>
        // }else{
        //   return <option value={item.uniqueid}>{item.vendorName}</option>
        // }
      })

    }

    console.log(pStatusArry, "pStatusArry")

    return { tierArry, accountArry, pStatusArry, mStatusArry, oneaccount, cStatusArry, vStatusArry }
  })

  console.log(data, "data")
  const noOfRow = data.accountArry.length
  // data.accountArry.push(
  //   {   
  //       sNo:noOfRow+1,
  //       account:<input type='text' placeholder='Add Account' value={newAccount} onChange={(e)=>setAccount(e.target.value)}/>,
  //       edit : <button onClick={()=>addAccount()}>Add Account</button>

  //   }
  // )








  const handleDateCompletedChange = (selectedDate) => {
    // console.log(selected,"jdksdskadsakd")

    setDateCompleted(selectedDate);
    const formattedDate = selectedDate ? format(selectedDate, 'MM/dd/yyyy') : '';
    // console.log(formattedDate,'kjshdkjsa')



    if (formattedDate) {
      setValue('Analysis_Status', 'Complete');
      setAnalysisStatus('Complete');
    } else {
      setValue('Analysis_Status', 'Pending');
      setAnalysisStatus('Pending');
    }
  };





  useEffect(() => {
    dispatch(RoleReducerAction(listRole_twoApi))
    dispatch(AccountReducerAction(accountApi))
    dispatch(TierListReducerActionviewtracker(viewmpimtracker))
    dispatch(UserListReducerAction(listUserApi_two))
    dispatch(GetMarketReducerAction(getMarket))
    dispatch(AccountReducerAction(crewCompanyApi))
    dispatch(AccountReducerAction(vendorApi))
    dispatch(AccountReducerAction('/manage_engineer_name'));
    dispatch(AccountReducerAction('/manage_account_name'));
    dispatch(AccountReducerAction('/manage_market_name'));
    dispatch(AccountReducerAction('/manage_inc_ticket'));
    dispatch(AccountReducerAction('/manage_site_id'));
    // dispatch(AccountReducerAction(viewmpimpo))
  }, [newAccount])
  const columns = [
    // {

    //   name: "sNo",
    //   label: "S. No.",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     searchable:false,
    //     setCellHeaderProps: () => ({
    //       style: {

    //         alignItem: "center",
    //         background: "#143b64",
    //         color: "white"

    //       }
    //     })
    //   }
    // },
    // {
    //   name: "lookup_value",
    //   label: "Name",
    //   options: {
    //     filter: true,
    //     setCellHeaderProps: () => ({
    //       style: {

    //         alignItem: "center",
    //         background: "#143b64",
    //         color: "white"

    //       }
    //     })
    //   }
    // },

    {
      name: "dateassigned",
      label: "DATE Assigned",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {

            alignItem: "center",
            background: "#143b64",
            color: "white"

          }
        })
      }
    },


    {
      name: "site_id",
      label: "SITE ID",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {

            alignItem: "center",
            background: "#143b64",
            color: "white"

          }
        })
      }
    },
    // {
    //   name: "account_name",
    //   label: "Account Name",
    //   options: {
    //     filter: true,
    //     setCellHeaderProps: () => ({
    //       style: {

    //         alignItem: "center",
    //         background: "#143b64",
    //         color: "white"

    //       }
    //     })
    //   }
    // },

    {
      name: "market_name",
      label: "MARKET NAME",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {

            alignItem: "center",
            background: "#143b64",
            color: "white"

          }
        })
      }
    },

    {
      name: "Analysis_Status_view",
      label: "ANALYSIS STATUS",
      options: {
        filter: true,
        print:false,
        setCellHeaderProps: () => ({
          style: {

            alignItem: "center",
            background: "#143b64",
            color: "white"

          }
        })
      }
    },


    {
      name: "Analysis_Status_print",
      label: "ANALYSIS STATUS",
      options: {
        filter: true,
        display:false,
        setCellHeaderProps: () => ({
          style: {

            alignItem: "center",
            background: "#143b64",
            color: "white"

          }
        })
      }
    },


    {
      name: "inc_ticket",
      label: "INC TICKET",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {

            alignItem: "center",
            background: "#143b64",
            color: "white"

          }
        })
      }
    },
    {
      name: "xPEX",
      label: "xPEX",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {

            alignItem: "center",
            background: "#143b64",
            color: "white"

          }
        })
      }
    },
    {
      name: "bridge_support",
      label: "BRIDGE SUPPORT",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {

            alignItem: "center",
            background: "#143b64",
            color: "white"

          }
        })
      }
    },

    {
      name: "assigned_to",
      label: "ASSIGNED TO",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {

            alignItem: "center",
            background: "#143b64",
            color: "white"

          }
        })
      }
    },

    {
      name: "shift",
      label: "SHIFT",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {

            alignItem: "center",
            background: "#143b64",
            color: "white"

          }
        })
      }
    },

    {
      name: "hoReqired_to",
      label: "HO REQUIRED TO",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {

            alignItem: "center",
            background: "#143b64",
            color: "white"

          }
        })
      }
    },

    {
      name: "notes_print",
      label: "NOTES",
      options: {
        filter: true,
        display:false,
        setCellHeaderProps: () => ({
          style: {

            alignItem: "center",
            background: "#143b64",
            color: "white"

          }
        })
      }
    },

    
    {
      name: "notes_display",
      label: "NOTES",
      options: {
        filter: true,
        print:false,
        setCellHeaderProps: () => ({
          style: {

            alignItem: "center",
            background: "#143b64",
            color: "white"

          }
        })
      }
    },
    {
      name: "ho_engineer",
      label: "HO ENGINEER",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {

            alignItem: "center",
            background: "#143b64",
            color: "white"

          }
        })
      }
    },
    {
      name: "date",
      label: "DATE COMPLETED",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {

            alignItem: "center",
            background: "#143b64",
            color: "white"

          }
        })
      }
    },

    {
      name: "action",
      label: "ACTION",
      options: {
        filter: false,
        sort: false,
        print: false,
        searchable: false,
        setCellHeaderProps: () => ({
          style: {

            alignItem: "center",
            background: "#143b64",
            color: "white"

          }
        })
      }
    }

  ];
  let row = [];

  const handleChange = (e) => {
    console.log("the current anser= ", e.target.value)
  }

  const AddCustomButton = () => (
    <fregment style={{ float: "right", display: "flex", flexDirection: row, justifyContent: "space-between" }}>
      {/* <div> */}
      {/* <Button className="btn btn-primary btn-xs mx-2 py-2 my-3" onClick={() => { handleShow(); reset({}); addformtype("Add") }}>Add Manage Engineer</Button> */}
      {/* <Button className="btn-xs mt-3 mr-2 mb-2 float-right" onClick={() => { filehandleShow(); reset({}); addformtype("Upload ") }}>Upload File</Button> */}
      {/* </div> */}

      {/* <CommonBulkUploader typeForm={""} afterLoad={managEngineer} shortCode={"ManageEngineer"} classes={'btn btn-primary btn-xs mx-2 py-2 my-3'} /> */}
      <Modal show={show} size="lg">
        <Modal.Header>
          <Modal.Title >{formtype} Schedule DashBoard</Modal.Title>
          <Button
            onClick={() => setShow(false)}
            variant=""
            className="close">
            <span>&times;</span>
          </Button>
        </Modal.Header>
        <Modal.Body >

          <div className="card " style={{ width: "100%" }}>
            <div
              className="accordion accordion-flush"
              id="accordionFlushExample"
            >
              <div className="accordion-item">
                <form onSubmit={handleSubmit(onSubmit)}>

                  <div>
                    <div className="accordion-body">
                      <div className="form-row mt-2 p-2">

                        <div className="form-group col-md-3">
                          <label for="exampleFormControlSelect1">
                            Date Assigned
                          </label>
                          <div
                            style={{ height: "40px" }}
                            type="text"
                            min={0}
                            max={100}
                            // className="form-control"
                            id="inputEmail4"
                            name="dateassigned">
                            <DatePicker
                              {...register("dateassigned")}
                              placeholderText="MM/dd/yyyy"
                              id="color-of-datepicker"
                              className="date-picker-changes"
                              popperPlacement='left'
                              selected={dateassigned}
                              autoComplete={"off"}
                              onChange={(e) => {
                                setdsate(e);
                              }}
                              dateFormat="MM/dd/yyyy"
                            />

                          </div>


                        </div>

                        {/* <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">
                            Analysis Status<span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            style={{ height: "32px" }}
                            type="text"
                            name="Analysis_Status"
                            className="custom-select-style form-control"
                            required
                            value={analysisStatus}
                            // onChange={(e) => setAnalysisStatus(e.target.value)}
                            onChange={handleStatusChange}
                            id="Analysis_Status"

                            {...register("Analysis_Status")}
                          >
                            <option value="Pending">Pending</option>
                            <option value="Complete">Complete</option>
                          </select>


                        </div> */}

                        {/*                         
                        // <div className="form-group col-md-3">
                        //   <label htmlFor="inputEmail4">ANALYSIS STATUS<span style={{ color: "red" }}>*</span></label>

                        //   <select
                        //     style={{ height: "32px" }}
                        //     type="text"
                        //     name="Analysis_Status"
                        //     className="custom-select-style form-control"
                        //     {...register("Analysis_Status")}
                        //   >
                 
                        //     <option value="Pending">Pending</option>
                        //     <option value="Complete">Complete</option>
                        //   </select>
                   
                        // </div> */}

                        {/* <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">INC TICKET<span style={{ color: "red" }}>*</span></label>

                    <select
                        style={{ height: "32px" }}
                        type="text"
                        name="inc_ticket"
                        className="custom-select-style form-control"
                        {...register("inc_ticket")}
                    >
                        {/* <option selected disabled value="">
              Select...
            </option> 
                        <option value="Pending">Pending</option>
                        <option value="Complete">Complete</option>
                    </select>
             
                </div> */}



                        {/* 
        <div className="form-group col-md-3">
          <label htmlFor="inputEmail4">Cell Id</label>
          <input
            style={{ height: "32px" }}
            type="text"
            min={0}
            max={100}
            className="form-control"
            id="inputEmail4"
            name="cell_id"
            {...register("cell_id")}
          />
        </div> */}

                        {/* <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">Account Name<span style={{ color: "red" }}>*</span></label>

                          <select
                            style={{ height: "32px" }}
                            type="text"
                            className="custom-select-style form-control"
                            required
                            {...register("account_name")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>

                            {
                              accountss?.map(item => {
                                return <option value={item?.accountName}>{item?.accountName}</option>
                              })
                            }
                          </select>


                        </div> */}

                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">Market Name<span style={{ color: "red" }}>*</span></label>

                          <select
                            style={{ height: "32px" }}
                            type="text"
                            className="custom-select-style form-control"
                            required
                            {...register("market_name")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            {/* <option value="Yes">Yes</option>
                        <option value="No">No</option> */}
                            {
                              marketnames?.map(item => {
                                return <option value={item?.marketName}>{item?.marketName}</option>
                              })
                            }
                          </select>


                          {/* {errors.sheduleShift && (
            <p className="error">{errors.sheduleShift.message}</p>
          )} */}
                        </div>


                        {/* <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">Site ID<span style={{ color: "red" }}>*</span></label>

                    <select
                        style={{ height: "32px" }}
                        required
                        type="text"
                        className="custom-select-style form-control"
                        {...register("site_id")}
                    >
                        <option selected disabled value="">
                            Select...
                        </option>
                        {
                            siteid?.map(item => {
                                return <option value={item?.site_id}>{item?.site_id}</option>
                            })
                        }
                    </select>
                </div> */}
                        {/* 
                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">Site ID<span style={{ color: "red" }}>*</span></label>

                          <select
                            style={{ height: "32px" }}
                            required
                            type="text"
                            className="custom-select-style form-control"
                            {...register("site_id")}
                            onChange={(e) => {
                              setValue(e.target.value)
                              dispatch(AccountReducerAction('/manage_inc_ticket/' + e.target.value));

                            }}

                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            {
                              siteid?.map(item => {
                                return <option value={item?.site_id}>{item?.site_id}</option>
                              })
                            }
                          </select>
                        </div> */}
                        <div className="form-group col-md-3">
                          <label for="exampleFormControlSelect1">SITE ID</label>
                          <input
                            style={{ height: "40px" }}
                            type="text"
                            className="form-control"
                            id="input "
                            autoComplete={false}
                            list="cars"
                            placeholder="enter Site Id"
                            {...register("site_id")}
                            onChange={(e) => {
                              setValue(e.target.value)
                              dispatch(AccountReducerAction('/manage_inc_ticket/' + e.target.value));
                            }}
                          />
                          <datalist id="cars">{optionss.site_idss}</datalist>

                        </div>




                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">
                            Analysis Status<span style={{ color: "red" }}>*</span>
                          </label>

                          <select
                            style={{ height: "32px" }}
                            type="text"
                            name="Analysis_Status"
                            className="custom-select-style form-control"
                            required
                            value={analysisStatus}
                            // onChange={(e) => setAnalysisStatus(e.target.value)}
                            onChange={handleStatusChange}
                            id="Analysis_Status"

                            {...register("Analysis_Status")}
                          >
                            <option value="Pending">Pending</option>
                            <option value="Complete">Complete</option>
                          </select>


                        </div>

                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">INC Ticket<span style={{ color: "red" }}>*</span></label>

                          <select
                            style={{ height: "32px" }}
                            type="text"
                            name="inc_ticket"

                            className="custom-select-style form-control"
                            required
                            {...register("inc_ticket")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>

                            {
                              console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!@@@@@@@@@@@@@@@", user)
                            }
                            <option value="Pending">Pending</option>
                            {
                              Array?.isArray(incTicket) && incTicket?.map(item => {
                                if (item?.inc_ticket == user?.inc_ticket) {
                                  return <option selected value={item?.value}>{item?.inc_ticket}</option>
                                }
                                else {
                                  return <option value={item?.value}>{item?.inc_ticket}</option>
                                }
                              })
                            }
                          </select>
                        </div>


                        {/* 
        <div className="form-group col-md-3">
          <label htmlFor="inputEmail4">Cell Id</label>
          <input
            style={{ height: "32px" }}
            type="text"
            min={0}
            max={100}
            className="form-control"
            id="inputEmail4"
            name="cell_id"
            {...register("cell_id")}
          />
        </div> */}

                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">xPEX<span style={{ color: "red" }}>*</span></label>

                          <select
                            style={{ height: "32px" }}
                            type="text"
                            className="custom-select-style form-control"
                            required
                            {...register("xPEX")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            <option value="CAPEX">CAPEX</option>
                            <option value="OPEX">OPEX</option>
                          </select>


                          {/* {errors.sheduleShift && (
            <p className="error">{errors.sheduleShift.message}</p>
          )} */}
                        </div>
                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">Bridge Support<span style={{ color: "red" }}>*</span></label>

                          <select
                            style={{ height: "32px" }}
                            type="text"
                            className="custom-select-style form-control"
                            required
                            {...register("bridge_support")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>


                          {/* {errors.sheduleShift && (
            <p className="error">{errors.sheduleShift.message}</p>
          )} */}
                        </div>

                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">Assigned To<span style={{ color: "red" }}>*</span></label>

                          <select
                            style={{ height: "32px" }}
                            type="text"
                            className="custom-select-style form-control"
                            required
                            {...register("assigned_to")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            {/* <option value="Yes">Yes</option>
                        <option value="No">No</option> */}
                            {
                              engineers?.map(item => {
                                return <option value={item?.name}>{item?.name}</option>
                              })
                            }
                          </select>


                          {/* {errors.sheduleShift && (
            <p className="error">{errors.sheduleShift.message}</p>
          )} */}
                        </div>

                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">Shift<span style={{ color: "red" }}>*</span></label>

                          <select
                            style={{ height: "32px" }}
                            type="text"
                            className="custom-select-style form-control"
                            required
                            {...register("shift")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            <option value="Day">Day</option>
                            <option value="MW">MW</option>
                          </select>


                          {/* {errors.sheduleShift && (
            <p className="error">{errors.sheduleShift.message}</p>
          )} */}
                        </div>


                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">HO Required</label>

                          <select
                            style={{ height: "32px" }}
                            type="text"
                            className="custom-select-style form-control"
                            {...register("hoReqired_to")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>


                          {/* {errors.sheduleShift && (
            <p className="error">{errors.sheduleShift.message}</p>
          )} */}
                        </div>

                        <div className="form-group col-md-3">
                          <label for="exampleFormControlSelect1">Notes</label>
                          <input
                            style={{ height: "32px" }}
                            type="text"
                            min={0}
                            max={100}
                            className="form-control"
                            id="inputEmail4"
                            name="notes"
                            {...register("notes")}
                          />
                        </div>


                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">HO Engineer</label>

                          <select
                            style={{ height: "32px" }}
                            type="text"
                            className="custom-select-style form-control"
                            {...register("ho_engineer")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            {/* <option value="SHASHANK">SHASHANK</option>
                        <option value="SHYAM">SHYAM</option> */}
                            {
                              engineers?.map(item => {
                                return <option value={item?.name}>{item?.name}</option>
                              })
                            }
                          </select>


                          {/* {errors.sheduleShift && (
            <p className="error">{errors.sheduleShift.message}</p>
          )} */}
                        </div>
                        {/* 
                        <div className="form-group col-md-3">
                    <label>Date Completed:</label>
                    <input
                        {...register("date")}
                        type="date"
                        value={dateCompleted}
                        onChange={handleDateCompletedChange} 
                    />
                </div> */}
                        <div className="form-group col-md-3">
                    <label htmlFor="exampleFormControlSelect1">Date Completed</label>
                    <div className="date-table" style={{ height: '45px' }}>
                        <DatePicker
                            {...register("date")}
                            placeholderText="MM/DD/YYYY"
                            id="color-of-datepicker"
                            //   className="date-picker-changes"
                            className="newFormatting date-picker-changes"

                            //   popperPlacement="left"
                            selected={dateCompleted}
                            autoComplete="off"
                            onChange={handleDateCompletedChange}
                            dateFormat="MM/dd/yyyy"
                        />
                    </div>
                </div>

                      </div>
                    </div>
                  </div>
                  <button type='submit' className='btn btn-primary col-xs' > Submit</button>
                </form>
              </div>

            </div>
          </div>

        </Modal.Body>
        <Modal.Footer>

        </Modal.Footer>
      </Modal>




      <Modal show={fileshow} onHide={filehandleClose} size="sm">
        <Modal.Header closeButton>
          <Modal.Title >{formtype} Crew</Modal.Title>
        </Modal.Header>
        {/* <Modal.Body> */}
        <form onSubmit={(e) => submitHandler(e)} encType="multipart/form-data" className="mx-2">
          <div className="input-group mb-3 fileSection">

            <div>
              <label class="custom-file-upload btn btn-outline-primary col-md-12">
                <input
                  type="file"
                  className="form-control btn btn-primary"
                  id="inputGroupFile04"
                  aria-describedby="inputGroupFileAddon04"
                  aria-label="Upload"
                  name="file"
                  multiple
                  onChange={uploadCsvFile}
                />
                <i class="fa fa-cloud-upload"></i> Choose File
              </label>
              {/* <label>Remarks</label>
                  <input type='text' className="form-control" value={remarks} onChange={(e)=>{setRemarks(e.target.value)}}></input> */}

            </div>

            <button
              className=" btn-primary"
              type="submit"
              id="inputGroupFileAddon04"
            >
              Submit
            </button>
          </div>

        </form>
        {/* <div className="form-row mt-2 p-2">
            <div>
              Crew File :
              <label class="custom-file-upload btn btn-outline-primary btn-xs col-md-12">
                <input style={{ height: "32px" }}
                  type="file"
                  className="form-control btn btn-primary"
                  id="inputGroupFile04"
                  aria-describedby="inputGroupFileAddon04"
                  aria-label="Upload"
                  name="file"
                  onChange={uploadCsvFile}

                />
                <i class="fa fa-cloud-upload"></i> Choose Crew File
              </label>
            </div>
          </div> */}


        {/* </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary btn-xs" onClick={filehandleClose}>
            Close
          </Button>
          <Button variant="primary btn-xs" onClick={submitHandler}>
            Upload File
          </Button>
        </Modal.Footer> */}
      </Modal>



    </fregment>
  )

  //    const data = [
  //     { name: "Joe James", company: "In Progress", city: "Yonkers", state: "NY" },
  //     { name: "John Walsh", company: "Completed", city: "Hartford", state: "CT" },
  //     { name: "Bob Herm", company: "Awaited", city: "Tampa", state: "FL" },
  //     { name: "James Houston", company: "NA", city: "Dallas", state: "TX" },
  //    ];





  return (
    <>
    <CommonModal
        modalSize={commonModalSize}
        setXlShow={setcommonModalState}
        xlShow={commonModalState}
        Body={commonModalBody}
        Header={commonModalHeader}
        Title={commonModalTitle}
      ></CommonModal>

      <ThemeProvider theme={getMuiThemeCommon()}>

        <MUIDataTable
          title={"Schedule Dashboard"}
          data={data.tierArry}
          columns={columns}
          // options={customDataTableOptionObject(AddCustomButton,false,"")}
          options={advancdExportOnecustomDataTableOptionObject(AddCustomButton, true, "SchedulerDashboard_", "", false)}
        />
      </ThemeProvider>
    </>
  )
}

export default ViewSchedulerTracker